import React, { useEffect, useState } from 'react';
import { Axis, Chart, Coordinate, Interaction, Interval, Legend, Tooltip } from 'bizcharts';
import { Button, Loading } from '@alifd/next';
import styles from './index.module.scss';
import { Servlets } from '@/service';
import utils from '@/common/utils';
import { history } from 'ice';

// 饼图下方的数据
const numType = ['流失订单数：', '流失占比：', '流失金额（元）：'];
let dataFlag = true; // 饼图是否有数据
let data = []; // 饼图数据

const DYOrderRange = () => {
  // 是否展示loading
  const [loadingVisible, setLoadingVisible] = useState(false);
  // 饼图右侧的数据
  const [initData, setInitData] = useState([
    { title: '付款订单', color: '#6699FF', num: 0, percent: 0 },
    { title: '未付款订单', color: '#52CCA3', num: 0, percent: 0 },
    { title: '取消订单', color: '#9580FF', num: 0, percent: 0 },
  ]);
  // 昨日新增订单
  const [salesData, setSalesData] = useState({});
  const [salesOpenData, setSalesOpenData] = useState({});

  /**
   * 获取是否开启催付字段，并处理开启与否的数据
   */
  const getSalseData = () => {
    Servlets('getSalesData', {}).then((res) => {
      if (res.data.open == 0) { // open:0 未开启催付
        dataFlag = false;
        const payPercent = +res.data.paymentOrder && +res.data.newOrder ? +res.data.paymentOrder / +res.data.newOrder : 0.5;
        data = [
          { title: '付款订单', color: '#6699FF', num: +res.data.paymentOrder, percent: payPercent.toFixed(2)*100 },
          {
            title: '取消订单',
            color: '#52CCA3',
            num: +res.data.newOrder - res.data.paymentOrder,
            percent: +(100 - payPercent.toFixed(2)*100),
          },
        ];
      } else if (res.data.open == 1) { // open:1 已开启催付
        setOpenData();
      }
      setInitData(data);
      setSalesData(res.data);
    });
  };

  /**
   * 已开启催付,设置环形图数据
   *
   newOrder 催款订单数量
   returnOrder 回款订单数量
   returnPayAmount 回款订单总金额
   returnPercentage 催款成功率

   百分比：挽回的：催款成功率
   未挽回：就是100%-催款成功率
   数量：  挽回的： returnOrder
   未挽回： newOrder - returnOrder
   */
  const setOpenData = () => {
    Servlets('getOpenSalesData', {}).then((res) => {
      if (res.data.newOrder && res.data.newOrder !== '0') {
        const payPercent = res.data.promptOrderNum && res.data.newOrder ? +res.data.promptOrderNum / +res.data.newOrder : 0.5;
        data = [
          { title: '支付订单', color: '#6699FF', num: +res.data.promptOrderNum, percent: payPercent.toFixed(2)*100 },
          {
            title: '取消订单',
            color: '#52CCA3',
            num: +(res.data.newOrder - res.data.returnOrder),
            percent: +(100 - payPercent.toFixed(2)*100),
          },
        ];
      } else {
        dataFlag = false;
        data = [
          { title: '支付订单', color: '#6699FF', num: 0, percent: +50 },
          { title: '取消订单', color: '#52CCA3', num: 0, percent: +50 },
        ];
      }
      setInitData(data);
      setSalesOpenData(res.data);
    });
  };

  /**
   * 开启催付
   */
  const toOpen = () => {
    history.push('/ordersCare');
  };

  const cols = {
    percent: {
      formatter: (val) => {
        val += '%';
        return val;
      },
    },
  };
  useEffect(() => {
    getSalseData();
  }, []);
  return (
    <div style={{ width: '49.5%' }} className="marginB-20">
      <Loading visible={loadingVisible}>
        <div className={`${styles.orderDataBox}`}>
          <div className={styles.topTitle}>昨日数据</div>
          <div style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            padding: '24px 40px 0',
          }}
          >
            <div style={{ width: '29.16%', marginTop: '43px' }}>
              <Chart height={190} data={initData} scale={cols} autoFit>
                <Coordinate type="theta" radius={0.75} innerRadius={0.75} />
                <Tooltip>
                  {(title, items) => {
                    // items 是个数组，即被触发tooltip的数据。
                    // 获取items的颜色
                    const { color } = items[0];
                    return (<div style={{ padding: '15px 0' }}>
                      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
                        <div style={{
                          width: 10,
                          height: 10,
                          backgroundColor: `${color}`,
                          borderRadius: '50%',
                          marginRight: '4px',
                        }}
                        />
                        <div> {items[0].data.title}</div>
                      </div>
                      <div>
                        {utils.numFormat(items[0].data.num)}
                        {dataFlag && <span>（占比{items[0].data.percent.toFixed(2)}%）</span>}
                        {!dataFlag && <span>（占比0%）</span>}
                      </div>
                    </div>);
                  }}
                </Tooltip>
                <Axis visible={false} />
                <Legend visible={false} />
                <Interval
                  position="percent"
                  adjust="stack"
                  color={['title', ['#6699FF', '#52CCA3', '#9580FF']]}
                  style={{
                    lineWidth: 1,
                    stroke: '#fff',
                  }}
                />
                <Interaction type="element-single-selected" />
              </Chart>
            </div>
            <div style={{ width: '63.84%' }}>
              <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                <div style={{ color: '#111111', fontSize: '14px', marginRight: '26px' }}>昨日新增订单</div>
                <div style={{
                  fontSize: '24px',
                  color: '#5D4CFF',
                }}
                >{salesData?.open === 1 ? utils.numFormat(+salesOpenData?.newOrder) : utils.numFormat(+salesData?.newOrder)}
                </div>
              </div>
              <div className={styles.boxRight} style={{ color: '#9CA7B6' }}>
                <div style={{ width: 100, textAlign: 'center' }}>类别</div>
                <div style={{ flex: '1', textAlign: 'center' }}>数量</div>
                <div className={styles.w50}>占比</div>
              </div>
              {
                initData.map((item, index) =>
                  (<div key={index} className={styles.boxRight}>
                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      width: 100,
                      paddingLeft: '20px',
                    }}
                    >
                      <div style={{
                        width: 10,
                        height: 10,
                        backgroundColor: item.color,
                        borderRadius: '50%',
                        marginRight: '4px',
                      }}
                      />
                      <div>{item.title}</div>
                    </div>
                    <div style={{ flex: '1', textAlign: 'center' }}>{utils.numFormat(item.num)}</div>
                    <div className={styles.w50}>{Number(item.percent).toFixed(2)}%</div>
                    {/* {item.percent} */}
                   </div>))
              }
            </div>
          </div>
          <div style={{ padding: '0 40px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div className={styles.bottomBox}>
                <div>
                  <span
                    className={'iconfont icon-icon4-35'}
                    style={{ fontSize: '14px', color: '#fbbc5a', marginRight: '8px' }}
                  />
                  <span>{salesData?.open === 1 ? '挽回订单数：' : '流失订单数：'}</span>
                </div>
                <div
                  style={{ color: '#FF3333' }}
                >{salesData?.open === 1 ? utils.numFormat(+salesOpenData?.returnOrder) : utils.numFormat(+salesData?.lostOrder)}
                </div>
              </div>
              <div className={styles.bottomBox}>
                <div>
                  <span
                    className={'iconfont icon-icon4-35'}
                    style={{ fontSize: '14px', color: '#fbbc5a', marginRight: '8px' }}
                  />
                  <span>{salesData?.open === 1 ? '挽回占比：' : '流失占比：'}</span>
                </div>
                <div
                  style={{ color: '#FF3333' }}
                >{salesData?.open === 1 ? salesOpenData.returnPercentage ?? '0%' : salesData.lostPercentage ?? '0%'}
                </div>
              </div>
              <div className={styles.bottomBox}>
                <div>
                  <span
                    className={'iconfont icon-icon4-35'}
                    style={{ fontSize: '14px', color: '#fbbc5a', marginRight: '8px' }}
                  />
                  <span>{salesData?.open === 1 ? '挽回金额：' : '流失金额：'}</span>
                </div>
                <div
                  style={{ color: '#FF3333' }}
                >{salesData?.open === 1 ? (+salesOpenData?.returnPayAmount ? +salesOpenData?.returnPayAmount / 100 : 0) : (+salesData?.lostAmount ? +salesData?.lostAmount / 100 : 0)}
                </div>
              </div>
            </div>
            {salesData?.open === 0 && <div style={{
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'center',
              marginTop: '20px',
            }}
            >
              <span style={{ marginRight: '12px', color: '#FF3333' }}>请尽快开启催付挽回流失订单</span>
              <Button type="primary" onClick={toOpen}>去开启</Button>
            </div>}
          </div>
        </div>
      </Loading>
    </div>
  );
};

export default DYOrderRange;
